import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ContentDelivery } from '../Footer Section/ContentDelivery';
import { authHeader, config } from '../../_helpers'
import { appService } from '../../_services';
import { de } from 'date-fns/locale';
import DocumentMeta from 'react-document-meta';

export class CartItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            key : '2',
            CartItem: [],
           
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }
    handleSelect(Activekey) {
        
    }

    // Handle Delete request for an employee
    handleDelete(id) {

        if (!window.confirm("Are you sure you want to remove this item?"))
            return;
        else {
            const requestOptions = {
                method: 'Delete',
                headers: authHeader(),
                //body: JSON.stringify({ cart })
            };
            fetch(config.apiUrl + '/Cart/Delete?id=' + id, requestOptions)
                .then(function (data) {
                    let currentTotalAmount = parseFloat(document.getElementById("spanTotalAmount").innerText);
                    currentTotalAmount -= parseFloat(document.getElementById("spanPrice_" + id).innerText);
                    document.getElementById("spanTotalAmount").innerText = currentTotalAmount.toFixed(2);
                    document.getElementById('dvitem_' + id).style.display = "none";
                    document.getElementById('dvitem_' + id).className = '';
                    var numItems = document.getElementsByClassName('list-group-item px-0 py-4').length;
                    
                    if (numItems <= 1) {
                         document.getElementById('btnproceedtocheckout').style.display = 'none';
                    }
                });
        }
    } 

    up(max, ctrl) {

        if (parseInt(document.getElementById("myNumber" + ctrl).value) + 1 == 11) {
            return false;
        }

        let qty = document.getElementById("myNumber" + ctrl).value;
        let unitPrice = document.getElementById("hdnPrice_" + ctrl).value;

        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            //body: JSON.stringify({ cart })
        };

        let updatedQty = parseInt(qty) + 1;
        fetch(config.apiUrl + '/Cart/UpdateQty?id=' + parseInt(ctrl) + '&Quantity=' + updatedQty, requestOptions)
            .then(cart => {

            });


        document.getElementById("myNumber" + ctrl).value = parseInt(document.getElementById("myNumber" + ctrl).value, 10) + 1;
        if (document.getElementById("myNumber" + ctrl).value >= parseInt(max, 10)) {
            document.getElementById("myNumber" + ctrl).value = max;
        }

        document.getElementById("spanPrice_" + ctrl).innerText = (unitPrice * document.getElementById("myNumber" + ctrl).value).toFixed(2);
        let currentTotalAmount = parseFloat(document.getElementById("spanTotalAmount").innerText);
        currentTotalAmount += parseFloat(unitPrice);
        document.getElementById("spanTotalAmount").innerText = currentTotalAmount.toFixed(2);

    }
    down(min, ctrl) {
        if (parseInt(document.getElementById("myNumber" + ctrl).value) - 1 == 0) {
            return false;
        }

        let qty = document.getElementById("myNumber" + ctrl).value;
        let unitPrice = document.getElementById("hdnPrice_" + ctrl).value;

        const requestOptions = {
            method: 'POST',
            headers: authHeader(),
            //body: JSON.stringify({ cart })
        };

        let updatedQty = parseInt(qty) - 1;
        fetch(config.apiUrl + '/Cart/UpdateQty?id=' + parseInt(ctrl) + '&Quantity=' + updatedQty, requestOptions)
            .then(cart => {

            });

        document.getElementById("myNumber" + ctrl).value = parseInt(document.getElementById("myNumber" + ctrl).value, 10) - 1;
        if (document.getElementById("myNumber" + ctrl).value <= parseInt(min, 10)) {
            document.getElementById("myNumber" + ctrl).value = min;
        }

        document.getElementById("spanPrice_" + ctrl).innerText = (unitPrice * document.getElementById("myNumber" + ctrl).value).toFixed(2);
        let currentTotalAmount = parseFloat(document.getElementById("spanTotalAmount").innerText);
        currentTotalAmount -= parseFloat(unitPrice);
        document.getElementById("spanTotalAmount").innerText = currentTotalAmount.toFixed(2);

    }

    render() {
        var CartItem = this.props.CartItem;
        var totalAmount = 0;
        var totalCurrencySymbol = '';
        
        var cart = Object.entries(CartItem).map((item) => {

            if (document.getElementById('btnproceedtocheckout') != null) {
                document.getElementById('btnproceedtocheckout').style.display = '';
            }
            totalAmount += parseFloat(item[1].price * item[1].quantity)
            totalCurrencySymbol = item[1].currencySymbol
            return (<li className="list-group-item px-0 py-4" id={'dvitem_' + item[1].id}>
                <div className="row" >
                    <div className="col-lg-1 col-md-2 col-sm-2 col-4"><img alt="" height="120px" src={'./images/books/' + item[1].imageName} /></div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-6">
                    {(() => {

                        if (item[1].isDetailProduct == true) {
                            return (
                                <p className="m-0 p-0 font-400"><div dangerouslySetInnerHTML={{ __html: item[1].articleTitle }}></div></p>
                            )
                        }
                        else {
                            return (
                                <p className="m-0 p-0 font-400"><div dangerouslySetInnerHTML={{ __html: item[1].title }}></div></p>
                            )
                        }
                    }
                        )()}
                        <p className="m-0 p-0"><div dangerouslySetInnerHTML={{ __html: item[1].editors }}></div></p>

                    {(() => {
                        if (item[1].isDetailProduct == true) {
                            return (
                                <p className="m-0 p-0"><div dangerouslySetInnerHTML={{ __html: item[1].title }}></div></p>
                            )
                        }
                    }
                    )()}

                </div>
                    {(() => {
                    if (item[1].deliveryTypeId == '3') {  /*3 for print*/
                        return (<div className="col-lg-2 col-2">
                            <div className="input-group-btn" >
                                <button id={'down_' + item[1].id} className="btn increment-boxPlus" onClick={() => this.down('1', item[1].id)}><span className="oi oi-minus" style={{ fontSize: '10px', color: '#474747', top: '-3px' }}></span></button>
                                <input disabled type="text" id={'myNumber' + item[1].id} className="increment-box center" defaultValue={item[1].quantity} />
                                <button id={'up_' + item[1].id} className="btn increment-boxPlus" onClick={() => this.up('10', item[1].id)}><span className="oi oi-plus" style={{ fontSize: '10px', color: '#474747', top: '-3px' }}></span></button>
                            </div>
                        </div>
                        )
                    }
                    else {
                        return (
                            <div className="col-lg-2 col-md-1 col-sm-1 col-2" style={{ paddingLeft: '4%' }}>1</div>
                        )
                    }
                }
                )()}
                <div className="col-lg-1 col-md-1 col-sm-1 col-3" >{item[1].documentType}</div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-6">{item[1].deliveryType}</div>
                <input type='hidden' value={item[1].price} id={'hdnPrice_' + item[1].id} />
                <div id={'dvPrice_' + item[1].id} className="col-lg-1 col-md-1 col-sm-1 col-2 green">{item[1].currencySymbol}<span id={'spanPrice_' + item[1].id}>{(item[1].price * item[1].quantity).toFixed(2)}</span></div>
                    <div className="col-lg-1 col-md-1 col-sm-1 col-1">

                        <a className="action" onClick={(id) => this.handleDelete(item[1].id > 0 ? item[1].id : (item[1].productId > 0 ? item[1].productId : item[1].productDetailId))}>
                        <span className="oi oi-x gray">
                        </span>
                    </a></div>

                </div>
            </li >)
    })
        const meta = {
            title: "Kluwer Law Online - Shopping Cart",
            //description: "Kluwer Law Online publishes peer-reviewed journals and manuals on various practice areas in international law. Browse within our practice areas to discover which titles we offer in your area of legal practice or on important legal subject-matters.",
            canonical: window.location.href,
            meta: {
                charset: "utf-8",
                name: {
                    keywords: "Shopping cart,Online Shopping,Manuals,practice area in international law,corporate and commercial law, litigation, labour law and transport law"
                }
            }
        }
    return(
        <DocumentMeta {...meta}>
          <div>
            
            <ul className="list-group list-group-flush mt-4">
                <li className="list-group-item px-0 py-4">

                    <div className="row">
                        <div className="col-4">Product(s)</div>
                        <div className="col-2">Quantity</div>
                        <div className="col-1">Type</div>
                        <div className="col-3">Access/delivery</div>
                        <div className="col-1">Price</div>

                    </div>
                </li>

                {cart}


            </ul>
            <ul className="list-group list-group-flush">
                <li className="list-group-item px-0 Bottomlist">
                    <div className="row">
                        <div className="col-md">
                            <p className="m-0 p-0 font-400">Got a question?</p>
                            <p className="m-0 p-0">Call us on 0800 123 4567 (Mon - Fri: 09.00 - 18.00 CET)</p>
                        </div>
                        <div className="col-1 font-400">Total</div>
                        <div className="col-1 green">{totalCurrencySymbol}<span id='spanTotalAmount'>{totalAmount.toFixed(2)}</span></div>
                        <div className="col-1"></div>
                    </div>
                </li>
            </ul>
           
            </div>
        </DocumentMeta>
        )
    }
}

export default CartItem;


// WEBPACK FOOTER //
// ./src/components/Shopping Cart/CartItem.jsx